export const REQUIRED_FIELD = "Campo obrigatório"

export const VALID_EMAIL = "Coloque um e-mail válido"

export const PASSWORD_MATCH = "Senhas não coincidem"

export const STRONG_PASSWORD = "Sua senha deve conter no mínimo 8 caráteres e incluir um número ou caractere especial."

export const VALID_CPF = "Coloque um Cpf Válido"

export const VALID_PHONE = "Coloque um Numero de Celular Válido"

export const has_accepted_terms = "Aceitar nossos termos e condições são necessários para utilizar o Futscore."
